import React, {useState} from 'react'
import PaystackIcon from "../../../assets/icons/Paystack"
import { usePaystackPayment, PaystackButton } from 'react-paystack'
import {useSubscriptionStore} from "../../../state/index"
import {useNavigate} from "react-router-dom"
import { processSubscription } from '../../../backend-services/subscription'
import toast from 'react-hot-toast'
interface PayStackConfig {
   reference: string;
   email: string;
   publicKey:string;
   amount: number;
   metadata: any;
}

interface PayWithPaystackProps{
  config: PayStackConfig;
  plan: string;
  id:number;
  close: () => void
}

const PayWithPaystack = ({config, plan, id, close}:PayWithPaystackProps) => {

  const navigate = useNavigate()

    const onSuccess =  () => {
      processSubscription(id)
      close()
      toast.success("Your Subscription was Successful")
      navigate("/settings?tab=subscription")
      };
    
      const onClose = () => {
        console.log('Payment closed');
      };

    const initializePayment = usePaystackPayment(config)
  return (
    <div className='flex flex-none '>
        <button className='bg-[#EDF2F5] rounded-[4px] py-[20px] px-[20px] flex flex-row gap-[72px]' onClick={() => initializePayment(onSuccess, onClose)}><span>Subscribe with </span> <PaystackIcon/></button>
    </div>
  )
}

export default PayWithPaystack